import React from "react";
import LocalizationManager from "@trainline-shareable/localization-manager";
const PACKAGE_ID = "@trainline-shareable/journey-live-tracker";
const resources = {
  default: () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-en-gb-translations" */
    "../../locales/en-GB.json"
  ),
  "cs-cz": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-cs-cz-translations" */
    "../../locales/cs-CZ.json"
  ),
  "da-dk": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-da-dk-translations" */
    "../../locales/da-DK.json"
  ),
  "de-at": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-de-at-translations" */
    "../../locales/de-AT.json"
  ),
  "de-ch": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-de-ch-translations" */
    "../../locales/de-CH.json"
  ),
  "de-de": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-de-de-translations" */
    "../../locales/de-DE.json"
  ),
  "en-gb": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-en-gb-translations" */
    "../../locales/en-GB.json"
  ),
  "en-us": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-en-us-translations" */
    "../../locales/en-US.json"
  ),
  "es-es": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-es-es-translations" */
    "../../locales/es-ES.json"
  ),
  "fr-ch": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-fr-ch-translations" */
    "../../locales/fr-CH.json"
  ),
  "fr-fr": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-fr-fr-translations" */
    "../../locales/fr-FR.json"
  ),
  "it-ch": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-it-ch-translations" */
    "../../locales/it-CH.json"
  ),
  "it-it": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-it-it-translations" */
    "../../locales/it-IT.json"
  ),
  "nb-no": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-nb-no-translations" */
    "../../locales/nb-NO.json"
  ),
  "nl-nl": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-nl-nl-translations" */
    "../../locales/nl-NL.json"
  ),
  "pl-pl": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-pl-pl-translations" */
    "../../locales/pl-PL.json"
  ),
  "pt-br": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-pt-br-translations" */
    "../../locales/pt-BR.json"
  ),
  "pt-pt": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-pt-pt-translations" */
    "../../locales/pt-PT.json"
  ),
  "sv-se": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-sv-se-translations" */
    "../../locales/sv-SE.json"
  ),
  "zh-cn": () => import(
    /* webpackChunkName: "shareable-journey-live-tracker-zh-cn-translations" */
    "../../locales/zh-CN.json"
  )
};
const LocalizationProvider = ({ locale = "en-gb", children }) => {
  const Skeleton = () => /* @__PURE__ */ React.createElement("div", null);
  return /* @__PURE__ */ React.createElement(LocalizationManager, {
    id: PACKAGE_ID,
    locale: locale.toLowerCase(),
    resources,
    loadingElement: /* @__PURE__ */ React.createElement(Skeleton, null)
  }, children);
};
var LocalizationProvider_default = LocalizationProvider;
export {
  LocalizationProvider_default as default
};
